export const pageLoaders = {
  dashboardLayout: () => import('@/pages/dashboard/DashboardLayout'),
  adminLayout: () => import('@/pages/admin/AdminLayout'),
  pushOptInPrompt: () => import('@/components/PushOptInPrompt'),
  landing: () => import('@/pages/Landing'),
  login: () => import('@/pages/Login'),
  register: () => import('@/pages/Register'),
  recoverAccount: () => import('@/pages/RecoverAccount'),
  requestPasswordReset: () => import('@/pages/RequestPasswordReset'),
  resetPassword: () => import('@/pages/ResetPassword'),
  paymentSuccess: () => import('@/pages/PaymentSuccess'),
  paymentCancel: () => import('@/pages/PaymentCancel'),
  publicLink: () => import('@/pages/PublicLink'),
  integrationDocs: () => import('@/pages/dashboard/integration/IntegrationDocs'),
  dashboardHome: () => import('@/pages/dashboard/Home'),
  transactions: () => import('@/pages/dashboard/Transactions'),
  links: () => import('@/pages/dashboard/Links'),
  kyc: () => import('@/pages/dashboard/Kyc'),
  fees: () => import('@/pages/dashboard/Fees'),
  settings: () => import('@/pages/dashboard/Settings'),
  support: () => import('@/pages/dashboard/Support'),
  transfer: () => import('@/pages/dashboard/Transfer'),
  deposit: () => import('@/pages/dashboard/Deposit'),
  services: () => import('@/pages/dashboard/Services'),
  profile: () => import('@/pages/dashboard/Profile'),
  exchange: () => import('@/pages/dashboard/Exchange'),
  integration: () => import('@/pages/dashboard/integration/Integration'),
  adminHome: () => import('@/pages/admin/AdminHome'),
  adminUsers: () => import('@/pages/admin/AdminUsers'),
  adminUserDetail: () => import('@/pages/admin/AdminUserDetail'),
  adminKyc: () => import('@/pages/admin/AdminKyc'),
  adminTransactions: () => import('@/pages/admin/AdminTransactions'),
  adminLogs: () => import('@/pages/admin/AdminLogs'),
  adminAdmins: () => import('@/pages/admin/AdminAdmins'),
  adminLinks: () => import('@/pages/admin/AdminLinks'),
  adminTransferConfig: () => import('@/pages/admin/AdminTransferConfig'),
  adminDepositConfig: () => import('@/pages/admin/AdminDepositConfig'),
  adminSupport: () => import('@/pages/admin/AdminSupport'),
  adminFeatures: () => import('@/pages/admin/AdminFeatures'),
  adminRates: () => import('@/pages/admin/AdminRates'),
  adminFees: () => import('@/pages/admin/AdminFees'),
  adminBenefits: () => import('@/pages/admin/AdminBenefits'),
  adminPaymentProviders: () => import('@/pages/admin/AdminPaymentProviders'),
  adminFunds: () => import('@/pages/admin/AdminFunds'),
  adminStatistics: () => import('@/pages/admin/AdminStatistics'),
  adminEmailNotifications: () => import('@/pages/admin/AdminEmailNotifications'),
  adminNotifications: () => import('@/pages/admin/AdminNotifications'),
  adminLegacyCleanup: () => import('@/pages/admin/AdminLegacyCleanup'),
};

const ROUTE_PAGES = {
  '/': 'landing',
  '/dashboard': 'dashboardHome',
  '/dashboard/transactions': 'transactions',
  '/dashboard/links': 'links',
  '/dashboard/kyc': 'kyc',
  '/dashboard/fees': 'fees',
  '/dashboard/settings': 'settings',
  '/dashboard/support': 'support',
  '/dashboard/transfer': 'transfer',
  '/dashboard/deposit': 'deposit',
  '/dashboard/services': 'services',
  '/dashboard/profile': 'profile',
  '/dashboard/exchange': 'exchange',
  '/dashboard/integration': 'integration',
  '/admin': 'adminHome',
  '/admin/users': 'adminUsers',
  '/admin/kyc': 'adminKyc',
  '/admin/links': 'adminLinks',
  '/admin/transactions': 'adminTransactions',
  '/admin/deposits': 'adminTransactions',
  '/admin/withdrawals': 'adminTransactions',
  '/admin/logs': 'adminLogs',
  '/admin/admins': 'adminAdmins',
  '/admin/transfer-config': 'adminTransferConfig',
  '/admin/deposit-config': 'adminDepositConfig',
  '/admin/support': 'adminSupport',
  '/admin/email-notifications': 'adminEmailNotifications',
  '/admin/notifications': 'adminNotifications',
  '/admin/features': 'adminFeatures',
  '/admin/rates': 'adminRates',
  '/admin/fees': 'adminFees',
  '/admin/benefits': 'adminBenefits',
  '/admin/payment-providers': 'adminPaymentProviders',
  '/admin/funds': 'adminFunds',
  '/admin/statistics': 'adminStatistics',
  '/admin/maintenance/legacy-merchant-api': 'adminLegacyCleanup',
};

export function prefetchPageForRoute(path) {
  const route = path.startsWith('/admin/users/') ? '/admin/users' : path;
  const loader = pageLoaders[ROUTE_PAGES[route]];
  if (!loader) return;

  const connection = typeof navigator !== 'undefined' ? navigator.connection : null;
  if (connection?.saveData || connection?.effectiveType === 'slow-2g') return;
  loader().catch(() => {});
}
